<template>
  <v-container class="easy-root">
    <v-spacer style="margin-top: 8rem;"></v-spacer>
    <easy-nav
        :icon="iconTradeContractHome"
        title="データ取引を行う"
        subtitle="データ取引を行います"
        to="/easy/tradeContractHome"
        block>
    </easy-nav>
    <easy-nav
        :icon="iconSystemHome"
        title="システムの管理を行う"
        subtitle="辞書や実装の管理、個別の設定といったシステムの管理を行います"
        to="/easy/systemHome"
        block>
    </easy-nav>
    <easy-nav
        :icon="iconHelp"
        title="ヘルプ"
        subtitle="システム不具合に関する問合せをしたり、使用方法に関するドキュメントを閲覧します"
        to="/easy/helpHome"
        block>
    </easy-nav>
    <div style="text-align: start;">
      <easy-back-button/>
    </div>
    <go-normal-btn/>
  </v-container>
</template>

<script>
import EasyNav from "@/components/pages/easy/EasyNav.vue";
import iconTradeContractHome from "./assets/icon_trade_contract_home.svg";
import iconSystemHome from "./assets/icon_system_home.svg";
import iconHelp from "./assets/icon_help_home.svg";
import EasyBackButton from "@/components/pages/easy/EasyBackButton.vue";
import GoNormalBtn from "@/components/pages/easy/GoNormalBtn.vue";

export default {
  name: "EasyRoot",
  components: {GoNormalBtn, EasyBackButton, EasyNav},
  data() {
    return {
      iconTradeContractHome,
      iconSystemHome,
      iconHelp
    }
  }
}
</script>

<style lang="scss" scoped src="./easy.scss"></style>
<style scoped>
.easy-root {
  max-width: 700px;
}
</style>
